class ScrollAnimation
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'scroll-animation--bound'
            @.$animationEl = @.$el.querySelector '.scroll-animation__animation'
            @.$areaEl = @.$el.querySelector '.scroll-animation__area'
            @.$contentEl = @.$el.querySelector '.scroll-animation__content'
            @.$headlineEl = @.$el.querySelector '.scroll-animation__headline'
            @.$milkboxEl = @.$el.querySelector '.milkbox'
            @.$scrollDownHintEl = @.$el.querySelector '.scroll-animation__scroll-down-hint'

            @.finished = @.$el.classList.contains 'scroll-animation--finished'
            @.hidden = @.$el.classList.contains 'scroll-animation--hidden'
            @.type = @.$el.dataset?.type ? false

            @.$el.classList.add 'scroll-animation--bound'
            @.InitEvents()
        return
    
    CumulativeOffsetCalc: (elem) ->
        self = @
        left = 0
        top = 0
        while true
            top += elem.offsetTop || 0
            left += elem.offsetLeft || 0
            elem = elem.offsetParent
            break unless elem
        return {
            left: left
            top: top
        }

    InitEvents: ->
        self = @
        document.addEventListener 'scroll', (e) ->
            if self.IsInViewport self.$el
                animationHeight = self.$areaEl.offsetHeight
                topPos = self.CumulativeOffsetCalc(self.$el).top
                scrolledProportional = ((window.scrollY - topPos) / animationHeight)
                self.SetHidden false

                if self.type == "milkbox" && self.$milkboxEl
                    if scrolledProportional > .1
                        self.$milkboxEl.classList.add 'milkbox--show-faces'
                    else
                        self.$milkboxEl.classList.remove 'milkbox--show-faces'
                    if self.$headlineEl
                        if scrolledProportional > .4
                            self.$headlineEl.classList.add 'scroll-animation__headline--shown'
                        else
                            self.$headlineEl.classList.remove 'scroll-animation__headline--shown'
                    rotation = (scrolledProportional - .11) * 100
                    rotation = if rotation < 0 then 0 else if rotation > 45 then 45 else rotation
                    self.$milkboxEl.style.transform = "rotateX(-16deg) rotateY(#{ rotation }deg) rotateZ(0)"
                    topX = (scrolledProportional - .56) * 700
                    topX = if topX < 0 then 0 else if topX > 100 then 100 else topX
                    self.$milkboxEl.style.top = "-#{ topX }vh"
                
                self.SetAnimationFinished self.IsInViewport(self.$contentEl)
                if ((window.scrollY - topPos) / (animationHeight - window.innerHeight)) > 1.05 || window.scrollY < topPos
                    self.SetHidden true
            else
                self.SetHidden true
            return
        #@.InitialScroll()
        return
    
    InitialScroll: ->
        # initial scroll to prevent svg render errors
        window.scrollTo(0,50)
        window.scrollTo(0,0)
        return
    
    IsInViewport: (elem) ->
        offsetTop = elem.offsetTop
        elemTop = @.CumulativeOffsetCalc(elem).top
        return elemTop + offsetTop <= window.pageYOffset + window.innerHeight && elemTop + elem.offsetHeight >= window.pageYOffset

    SetAnimationFinished: (finished) ->
        @.finished = finished
        if finished
            @.$el.classList.add 'scroll-animation--finished'
        else
            @.$el.classList.remove 'scroll-animation--finished'
        return
    
    SetHidden: (hidden) ->
        @.hidden = hidden
        if hidden
            @.$el.classList.add 'scroll-animation--hidden'
        else
            @.$el.classList.remove 'scroll-animation--hidden'
        
        if @.$scrollDownHintEl
            @.$scrollDownHintEl.dispatchEvent new CustomEvent 'scroll-down-hint-shown', {
                bubbles: false
                detail: {
                    shown: !hidden
                }
            }
        return

BindScrollAnimations = ->
    document.querySelectorAll '.scroll-animation:not(.scroll-animation--bound)'
        .forEach (el) ->
            new ScrollAnimation el
            return
    return

window.addEventListener 'bind-components', BindScrollAnimations